module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-item list-item-arrow",
    on: {
      "click": _vm.onclick
    }
  }, [_c('menu-vertical', {
    attrs: {
      "path": _vm.path
    }
  }, [_c('span', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-right": "20px",
      "color": "#aaa"
    },
    attrs: {
      "slot": "dock"
    },
    slot: "dock"
  }, [_vm._v(_vm._s(_vm.dock))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a1f213f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demohelper/demomenu.vue
// module id = 276
// module chunks = 36